module.exports = __webpack_public_path__ + "static/media/doc.b213fcc0.png";